import { React, useState, Fragment, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import apiService from '../../services/apiServices';
import validationSchema from '../../services/validationSchema';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { yupResolver } from '@hookform/resolvers/yup';

export default function AddDepartment() {
  //const classes = useStyles();
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [department, setDepartment] = useState([]);
  const [months, setMonths] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const statuses=[{id:1,name:"aktiv"},{id:2,name:"inaktiv"}]

  useEffect(() => {
    apiService()
      .get('department')
      .then((response) => {
        if (response.success) {
          setDepartment(response.data);
          //console.log(response.data);
        } else {
          alert('Error:' + response.errorMessage);
        }
      });
    apiService()
      .get('months')
      .then((response) => {
        if (response.success) {
          setMonths(response.data);
          //console.log(response.data);
        } else {
          alert('Error:' + response.errorMessage);
        }
      });
  }, []);

  const onSubmit = (data) => {
      data.Status=data.Status.id
    console.log(data);
    apiService()
      .post('department', data)
      .then((response) => {
        if (response.success) {
          setToast({
            open: true,
            message: 'U ruajten me sukses!',
            variant: 'success',
          });
        } else {
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  return (
    <div className="">
      <Fragment>
        <Toast {...toast} />
        <TopActions
          newHref="/departmentlist/adddepartment"
          save={handleSubmit(onSubmit)}
        />

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Lloji i Departamentit
            </Typography>
            <form>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={3} lg={4}>
                  <InputController
                    placeholder="Emri i Departamentit"
                    error={errors.Name}
                    control={control}
                    name="Name"
                    register={{ ...register('Name') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={4}>
                  <InputController
                    placeholder="Inicialet"
                    error={errors.Name}
                    control={control}
                    name="Short"
                    register={{ ...register('Short') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={4}>
                  <SelectController
                    placeholder="Statusi"
                    error={errors.status}
                    control={control}
                    options={statuses}
                    name="Status"
                    register={{ ...register('Status') }}
                  />
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Fragment>
    </div>
  );
}
